<template>
	<q-card
		class="full-width full-height shadow-transition relative-position library cursor-pointer bg-grey-9 - text-white"
		:class="class_hover"
		@mouseover="setClassHover('mouseover')"
		@mouseleave="setClassHover('mouseleave')"
		@click="openLibrary()"
	>
		<div class="q-img">
			<div class="img">
				<img
					class="full-width"
					:src="getImage"
					@error="getImageError"
					:alt="getAltImage"
					@click="openCourse()"
				/>
			</div>
		</div>

		<q-card-section>
			<div class="text-subtitle2 title">
				{{ library.title }}
			</div>
		</q-card-section>

		<q-card-actions class="text-grey-5 absolute-bottom">
			<div class="row full-width q-col-gutter-md">
				<div class="col-12 text-center">
					<q-btn size="sm" dense flat :icon="$extensionIcon(library.extension).icon">
						<span class="q-ml-sm">{{ library.extension }} - {{ library.size }}</span>
					</q-btn>

					<q-btn size="sm" dense flat icon="fal fa-download">
						{{ library.hits }}
					</q-btn>
				</div>
			</div>
		</q-card-actions>

		<q-tooltip
			v-if="checkTrailEnrolled"
			anchor="center middle"
			self="center middle"
			class="bg-primary"
			style="font-size: 16px"
		>
			{{ $t('you_need_to_enroll_before_starting_this_content') }}
		</q-tooltip>

		<q-tooltip
			v-if="!checkTrailEnrolled && is_blocked && $route.name === 'trail'"
			anchor="center middle"
			self="center middle"
			class="bg-primary"
			style="font-size: 16px"
		>
			<span v-if="content.is_hierarchy_blocked">
				{{
					`${$t('you_need_to_finish_the_content')} ${content.parent_title} ${$t(
						'before_starting_this'
					)}`
				}}
			</span>

			<span v-else-if="content.availability_date_block">
				{{
					`${$t('this_content_will_be_available_on')} ${$dateUtil.fDateNoTimezone(
						content.availability_date
					)}`
				}}
			</span>
		</q-tooltip>

		<q-inner-loading :showing="loading">
			<q-spinner-facebook size="1rem" color="text-blue-grey-4" />
		</q-inner-loading>
	</q-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'LibraryCard',

	props: ['library', 'origin', 'is_blocked', 'trail', 'content'],

	data() {
		return {
			class_hover: '',
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			country_areas: 'site_lists/country_areas',
			groups_user: 'site_lists/groups_user',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getImage() {
			const image = this.library.image_urls.find((e) => e.name === 'original')
			if (image) return image.image_url
			else {
				let obj = this.clients.find((obj) => obj.id == this.id_user_client_selected)
				if (obj) return obj.group_library_file_placeholder
				else return ''
			}
		},

		getAltImage() {
			if (this.library.library_image_alt_texts?.length) {
				return this.library.library_image_alt_texts[this.library.library_image_alt_texts.length - 1]
					.alt_text
			}
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) {
				if (obj.group_library_file_placeholder_alt_text != '')
					return obj.group_library_file_placeholder_alt_text
			} else return ''
		},

		checkTrailEnrolled() {
			if (this.trail && this.useTrailSubscription) {
				if (this.trail.is_mandatory || this.trail.is_self_subscribed || this.trail.is_subscribed)
					return false
				else return true
			} else return false
		},

		useTrailSubscription() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})
			if (obj) return obj.use_trail_subscription
			else return false
		},
	},

	methods: {
		openLibrary() {
			if (!this.is_blocked && !this.checkTrailEnrolled) {
				this.$q.loading.show()

				const url =
					this.$route.name !== 'trail'
						? `/etraining_library_files/files/${this.library.id}/`
						: `/etraining_trails/trail/${this.$route.params.id}/library_file/${this.library.id}/`

				this.$axios
					.get(url)
					.then((response) => {
						this.$emit('openLibrary', response.data)
					})
					.catch((e) => {
						this.$q.notify({
							message: this.$t('library_file_not_found'),
							type: 'negative',
							icon: 'fal fa-ban',
						})
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		getImageError(event) {
			let obj = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) {
				if (
					obj.group_library_file_placeholder !== 'https://image.jpg' &&
					obj.group_library_file_placeholder !== ''
				)
					event.target.src = obj.group_library_file_placeholder
				else event.target.src = 'placeholders/file.png'
			} else event.target.src = 'placeholders/file.png'
		},

		setClassHover(state) {
			if (this.is_blocked || this.checkTrailEnrolled) this.class_hover = 'disabled'
			else {
				if (state === 'mouseover') this.class_hover = 'shadow-5'
				else this.class_hover = ''
			}
		},
	},

	created() {
		if (this.is_blocked || this.checkTrailEnrolled) this.class_hover = 'disabled'
	},
}
</script>

<style lang="scss" scoped>
.library {
	min-height: 250px;
}
.title {
	font-style: normal;
	font-weight: bold;
	font-size: 12px;
	line-height: 1.5em;
	height: 3em;
	overflow: hidden;
}
.type {
	font-style: normal;
	font-weight: 500;
	font-size: 0.7rem;
}
.q-img {
	min-height: 26%;
	.img {
		padding-bottom: 55%;
		img {
			position: absolute;
			top: 0;
			left: 0;
		}
	}
}
</style>
